module.exports = __webpack_public_path__ + "img/legend.9e821af4.svg";